// window['ablyft'] = window['ablyft'] || [];
// window['ablyft'].push({
//     eventType: 'forceVariation',
//     experimentId: 12345678,
//     variationId: 98765432
// });

class ABTestExperimentsSynchronizer {
	experiments = {
		magnesiumPage: {
			experimentId: 87318258,
			variations: {
				a: 88866043, // higher price
				b: 75970112, // lower price
			},
		},
		magnesiumPDP: {
			experimentId: 63470214,
			variations: {
				a: 68276087, // higher price
				b: 72026095, // lower price
			},
		},
	};

	constructor() {
		this.cookie = this.getCookie('ablyft_exps');
		if (!this.cookie) {
			console.log('No experiments found');
			return;
		}
		this.cookie = JSON.parse(this.cookie);
		console.log('cookie', this.cookie);
		this.value = this.has(this.experiments.magnesiumPage.experimentId);
		const pageVariation = this.value ? this.getVariationId(this.experiments.magnesiumPage.experimentId) : null;
		console.log('Magnesium PAGE is init: ', this.value);
		this.value = this.has(this.experiments.magnesiumPDP.experimentId);
		console.log('Magnesium PDP is init: ', this.value);

		// IF page set and pdp not set so set pdp to the same like variation
		if (pageVariation && !this.has(this.experiments.magnesiumPDP.experimentId)) {
			const pdpVariation =
				pageVariation === this.experiments.magnesiumPage.variations.a
					? this.experiments.magnesiumPDP.variations.a
					: this.experiments.magnesiumPDP.variations.b;
			this.setExperiment(this.experiments.magnesiumPDP.experimentId, pdpVariation);
		}
		// Check which variation is active for PDP
		if (this.has(this.experiments.magnesiumPDP.experimentId)) {
			const variationIdName =
				this.getVariationId(this.experiments.magnesiumPDP.experimentId) === this.experiments.magnesiumPDP.variations.a
					? 'higher price'
					: 'lower price';
			console.log('Magnesium PDP variation: ', variationIdName);
		}
		// Check if both experiments are set but not the same variation
	}

	getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		// Make cookie to json object
		if (parts.length === 2) return parts.pop().split(';').shift();
	}

	has(key) {
		return this.cookie[key] !== undefined;
	}

	getVariationId(experimentId) {
		return this.cookie[experimentId];
	}

	setExperiment(experimentId, variationId) {
		const experimentName = Object.keys(this.experiments).find(
			(key) => this.experiments[key].experimentId === experimentId,
		);
		const variationName =
			variationId === this.experiments[experimentName].variations.a ? 'higher price' : 'lower price';
		console.log('Set experiment', experimentName, 'with variation', variationName);
		window['ablyft'] = window['ablyft'] || [];
		window['ablyft'].push({
			eventType: 'forceVariation',
			experimentId: experimentId,
			variationId: variationId,
		});
		this.setCookie('ablyft_synchronized', 'synchronized');
	}

	// Check if both experiments are set but not the same variation
	checkIfBothExperimentsAreSet() {
		if (this.has(this.experiments.magnesiumPage.experimentId) && this.has(this.experiments.magnesiumPDP.experimentId)) {
			const magnesiumPageVariation = this.getVariationId(this.experiments.magnesiumPage.experimentId);
			const magnesiumPDPVariation = this.getVariationId(this.experiments.magnesiumPDP.experimentId);
			if (magnesiumPageVariation !== magnesiumPDPVariation) {
				// Set the same variation for PDP
				const pdpVariation =
					magnesiumPageVariation === this.experiments.magnesiumPage.variations.a
						? this.experiments.magnesiumPDP.variations.a
						: this.experiments.magnesiumPDP.variations.b;
			}
		}
	}
	// Set bucketing for experiment with url ?ablyft_set_bucketing=["70196580_62929571","79933427_10208099"]
	forceExperiment(experimentId, variationId) {
		const url = new URL(window.location.href);
		// set bucketing for experiment
		url.searchParams.set('ablyft_set_bucketing', JSON.stringify([experimentId, variationId]));
		window.location.href = url.href;
	}

	setCookie(name, value) {
		document.cookie = `${name}=${value}; path=/`;
	}
}

// document.addEventListener('DOMContentLoaded', () => {
// 	// const url = window.location.href;
// 	// const isPDP = url.includes('magnesium');
// 	// if (isPDP) new ABTestExperimentsSynchronizer();
// });

// document.addEventListener('visitorConsentCollected', function (event) {
	// console.log('visitorConsentCollected', event.detail);
	// new ABTestExperimentsSynchronizer();
// });

// https://pharmasgp.myshopify.com/products/puresgp-magnesium-komplex-1?preview_theme_id=165791203613
// https://pharmasgp.myshopify.com/products/puresgp-magnesium-komplex?preview_theme_id=165791203613
// Set bucketing for experiment with url for lower price both experiments ?ablyft_set_bucketing=["87318258_75970112","63470214_72026095"]
// Set bucketing for experiment with url for higher price both experiments ?ablyft_set_bucketing=["87318258_88866043","63470214_68276087"]
// Set bucketing for experiment with url for lower price PDP ?ablyft_set_bucketing=["63470214_72026095"]
// Set bucketing for experiment with url for higher price PDP ?ablyft_set_bucketing=["63470214_68276087"]
// Set bucketing for experiment with url for lower price PAGE ?ablyft_set_bucketing=["87318258_75970112"]
// Set bucketing for experiment with url for higher price PAGE ?ablyft_set_bucketing=["87318258_88866043"]
